import { createFileRoute } from '@tanstack/react-router';
import { DripGoalSubTab } from '@/components/admin/DripGoalSubTab';

function Page() {
  return <DripGoalSubTab goal='prospects' />;
}

export const Route = createFileRoute('/admin/drip-campaigns/prospects')({
  component: Page,
});
